// Older browser support fix
// https://github.com/johndatserakis/koa-vue-notes-api/issues/1
import 'es6-promise/auto'

import Vue from 'vue'
import App from './App.vue'

import router from './router'
import store from './store'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import Toasted from 'vue-toasted'
Vue.use(Toasted, {
    theme: 'primary',
    position: 'top-center',
    duration: 2300,
    singleton: true
})

import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, {
    color: '#ADE027',
    failedColor: '#F43D41',
    thickness: '3px',
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 300
    },
    autoRevert: true,
    location: 'top',
    inverse: false
})

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import 'vue-progress-path/dist/vue-progress-path.css'
import VueProgress from 'vue-progress-path'
Vue.use(VueProgress)

import flatPickr from 'vue-flatpickr-component'
Vue.use(flatPickr)
import 'flatpickr/dist/flatpickr.css'
import 'flatpickr/dist/themes/dark.css'
Vue.use(flatPickr)

import SocialSharing from 'vue-social-sharing'
Vue.use(SocialSharing)

import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
    id: 'UA-105715632-9',
    debug: {
        sendHitTask: process.env.NODE_ENV === 'production'
    },
    checkDuplicatedScript: true,
    router
})

import axios from 'axios'

import truncate from '@/common/truncate'
Vue.filter('truncate', truncate)

// Font awesome work

import fontawesome from '@fortawesome/fontawesome'
import faCheck from '@fortawesome/fontawesome-pro-light/faCheck'
import faCheckCircle from '@fortawesome/fontawesome-pro-light/faCheckCircle'
import faSearch from '@fortawesome/fontawesome-pro-light/faSearch'
import faPhone from '@fortawesome/fontawesome-pro-light/faPhone'
import faArrowAltUp from '@fortawesome/fontawesome-pro-light/faArrowAltUp'
import faArrowAltDown from '@fortawesome/fontawesome-pro-light/faArrowAltDown'
import faArrowAltDownSolid from '@fortawesome/fontawesome-pro-solid/faArrowAltDown'
import faArrowDownSolid from '@fortawesome/fontawesome-pro-solid/faArrowDown'
import faStar from '@fortawesome/fontawesome-pro-solid/faStar'
import faPencil from '@fortawesome/fontawesome-pro-light/faPencil'
import faImages from '@fortawesome/fontawesome-pro-light/faImages'
import faLongArrowRight from '@fortawesome/fontawesome-pro-light/faLongArrowRight'
import faInfoCircle from '@fortawesome/fontawesome-pro-light/faInfoCircle'
import faRocket from '@fortawesome/fontawesome-pro-light/faRocket'
import faRss from '@fortawesome/fontawesome-pro-light/faRss'
import faBriefcase from '@fortawesome/fontawesome-pro-light/faBriefcase'
import faCode from '@fortawesome/fontawesome-pro-light/faCode'
import faPaperPlane from '@fortawesome/fontawesome-pro-light/faPaperPlane'
import faEnvelope from '@fortawesome/fontawesome-pro-light/faEnvelope'
import faGavel from '@fortawesome/fontawesome-pro-light/faGavel'
import faCloud from '@fortawesome/fontawesome-pro-light/faCloud'
import faComment from '@fortawesome/fontawesome-pro-light/faComment'
import faPaintBrush from '@fortawesome/fontawesome-pro-light/faPaintBrush'
import faThumbsUp from '@fortawesome/fontawesome-pro-light/faThumbsUp'
import faExternalLink from '@fortawesome/fontawesome-pro-light/faExternalLink'
import faCog from '@fortawesome/fontawesome-pro-light/faCog'
import faPlayCircle from '@fortawesome/fontawesome-pro-light/faPlayCircle'
import faPlayCircleRegular from '@fortawesome/fontawesome-pro-regular/faPlayCircle'
import faCalendarAlt from '@fortawesome/fontawesome-pro-light/faCalendarAlt'
import faCalendarPlus from '@fortawesome/fontawesome-pro-light/faCalendarPlus'
import faGlobe from '@fortawesome/fontawesome-pro-light/faGlobe'
import faGlobeSolid from '@fortawesome/fontawesome-pro-solid/faGlobe'
import faCaretDown from '@fortawesome/fontawesome-pro-light/faCaretDown'
import faTwitter from '@fortawesome/fontawesome-free-brands/faTwitter'
import faFacebookF from '@fortawesome/fontawesome-free-brands/faFacebookF'
import faInstagram from '@fortawesome/fontawesome-free-brands/faInstagram'
import faLinkedin from '@fortawesome/fontawesome-free-brands/faLinkedin'
import faYoutube from '@fortawesome/fontawesome-free-brands/faYoutube'
import faPinterest from '@fortawesome/fontawesome-free-brands/faPinterest'

fontawesome.library.add(
    faCheck,
    faCheckCircle,
    faSearch,
    faPhone,
    faArrowAltUp,
    faArrowAltDown,
    faArrowAltDownSolid,
    faArrowDownSolid,
    faPencil,
    faImages,
    faLongArrowRight,
    faInfoCircle,
    faRocket,
    faBriefcase,
    faRss,
    faCode,
    faPaperPlane,
    faEnvelope,
    faGavel,
    faCloud,
    faComment,
    faPaintBrush,
    faThumbsUp,
    faExternalLink,
    faCog,
    faPlayCircle,
    faPlayCircleRegular,
    faCalendarAlt,
    faCalendarPlus,
    faGlobe,
    faGlobeSolid,
    faCaretDown,
    faTwitter,
    faFacebookF,
    faInstagram,
    faLinkedin,
    faYoutube,
    faPinterest,
    faStar
)

import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
Vue.component('font-awesome-icon', FontAwesomeIcon)

import VueTippy from 'vue-tippy'
Vue.use(VueTippy)

import VueYouTubeEmbed from 'vue-youtube-embed'
Vue.use(VueYouTubeEmbed)

import VueFloatLabel from 'vue-float-label'
Vue.use(VueFloatLabel)

import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
Vue.component('vue-cookie-accept-decline', VueCookieAcceptDecline)

import VueAnime from '@/common/animejs'
Vue.use(VueAnime)

import 'vue2-animate/dist/vue2-animate.css'

import './assets/css/app.scss' // app styles

// The following two interceptor blocks are strictly for
// attaching the top-loading bar to all axios requests and
// stoping the bar on all responses.
axios.interceptors.request.use(function (config) {
    router.app.$Progress.start()
    return config
}, function (error) {
    router.app.$Progress.fail()
    return Promise.reject(error)
})
axios.interceptors.response.use(function (response) {
    router.app.$Progress.finish()
    return response
}, function (error) {
    router.app.$Progress.fail()
    return Promise.reject(error)
})

Vue.config.productionTip = true

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app')
